var swiper = new Swiper(".block_customer-product-slider-info", {
    slidesPerView: 4,
    spaceBetween: 20,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    mousewheel: {
        forceToAxis: true,
    },
    navigation: {
        nextEl: ".block_shop-categories .block_slider-right-arrow",
        prevEl: ".block_shop-categories .block_slider-left-arrow",
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        400: {
            slidesPerView: 1,
        },
        480: {
            slidesPerView: 1,
        },
        749: {
            slidesPerView: 3,
        },
        989: {
            slidesPerView: 3,
        },
        1280: {
            slidesPerView: 4,
        },
    },
});